<template>
  <div class="wall">
    <div class="wall-head">店铺设置</div>
    <rs-form ref="userForm" v-loading="loading" :model="formData" :rules="rules" :errors="formError" label-width="120px" class="mt-35 p-30 container">
      <el-form-item label="店铺名称" prop="name">
        <el-input v-model="formData.name"></el-input>
      </el-form-item>
      <el-form-item label="店铺LOGO" prop="logo">
        <uploader v-model="formData.logo" />
      </el-form-item>
      <el-form-item label="店铺简介" prop="description">
        <el-input
        type="textarea"
        :rows="4"
        v-model="formData.description"
        maxlength="128"
        show-word-limit
      ></el-input>
      </el-form-item>
      <el-form-item label="经营地址" required prop="address">
        <div class="flex-items-center">
          <el-cascader style="width: 420px" v-if="showAddress" v-model="areas" :props="props"></el-cascader>
          <el-input
            class="ml-10"
            v-model="formData.address.place"
            maxlength="30"
            show-word-limit></el-input>
          </div>
      </el-form-item>
      <rs-form-item label="客服电话" required>
        <el-input v-model="formData.tel"></el-input>
      </rs-form-item>
      <rs-form-item label="绑定服务号">
        <el-button :loading="qrLoading" @click="handleBindQr" type="success" size="small">绑定服务号接收通知</el-button>
      </rs-form-item>
      <el-form-item>
        <button class="btn-primary-orange" @click="saveShopInfo">
          <span>保存</span>
        </button>
      </el-form-item>
    </rs-form>
  </div>
</template>

<script>
import { getShop, updateShop, bindServiceQr } from '@/api/shop.js'
import { getArea } from '@/api/area.js';
import { mapGetters } from 'vuex'
import Uploader from '@/components/Uploader.vue';
export default {
  components: {
    Uploader
  },
  data() {
    return {
      formData: {
        name: '',
        logo: '',
        description: '',
        address: {
          place: '',
        },
        tel: ''
      },
      areas: [110000, 110100, 110101],
      rules: {
        name: [
          { required: true, message: '请输入店铺名称', trigger: 'blur' },
          { min: 3, max: 30, message: '店铺名称长度在 3 到 15 个字符之间', trigger: 'blur' }
        ],
        logo: [
          { required: true, message: '请上传店铺图标', trigger: 'change' }
        ],
        description: [
          { required: true, message: '店铺简介不能为空', trigger: 'blur' }
        ],
      },
      props: {
        value: 'id',
        label: 'name',
        lazy: true,
        lazyLoad (node, resolve) {
          const { level } = node;
          let pid = 0;
          if (level > 0) {
            pid = node.value
          }
          getArea(pid).then(res => {
            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
            if (pid == 0) {
              resolve(res);
            } else {
              resolve(res.subs.map(item => {
                item.leaf = (level > 1)
                return item;
              }));
            }
          });
        }
      },
      showAddress: true,
      loading: false,
      formError: {},
      qrLoading: false
    }
  },
  created() {
    // 加载店铺信息
    this.loadShopInfo();
  },
  computed: {
    ...mapGetters([
      'userInfo',
    ])
  },
  methods: {
    // 加载店铺信息
    async loadShopInfo() {
      this.loading = true;
      const res = await getShop(this.userInfo.shop)
      setTimeout(() => {
        this.loading = false;
      }, 500);

      let _address = res.address || {};
      this.areas = [
        _address.province_id || 0,
        _address.city_id || 0,
        _address.district_id || 0
      ];

      // 强制重新渲染地址选择框
      this.showAddress = false;
      this.$nextTick(() => {
        this.showAddress = true;
      })

      if (!res.address) {
        delete res.address
      }

      this.formData = Object.assign(this.formData, res);
    },
    handleBindQr() {
      this.qrLoading = true
      bindServiceQr().then(res => {
        this.qrLoading = false
        this.$alert('<img style="width:390px" src="https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=' + res.ticket + '">', '使用微信扫一扫关注绑定服务号', {
          dangerouslyUseHTMLString: true
        });
      }).catch(e => {
        this.$alert(JSON.stringify(e.data), '严重错误', {
          confirmButtonText: '确定',
        });
        this.qrLoading = false
      })
    },
    // 保存用户信息
    saveShopInfo(e) {
      e.preventDefault();
      this.$refs['userForm'].validate((valid) => {
        if (!valid) return false;
        this.formData.address = {
          place: this.formData.address.place,
          province_id: this.areas[0] || 0,
          city_id: this.areas[1] || 0,
          district_id: this.areas[2] || 0,
        };
        // 发送请求
        updateShop(this.userInfo.shop, this.formData).then(() => {
          this.$message.success('信息修改成功');
          this.$store.dispatch('GetInfo');
        }).catch(err => {
          if (err.status == 400) { 
            this.formError = err.data || {}
            if (this.formError.address && this.formError.address.place) {
              this.formError.address = this.formError.address.place
            }
          } else {
            this.$alert(JSON.stringify(err.data), '严重错误', {
              confirmButtonText: '确定',
            });
          }
        })
      });
    }
  }
}
</script>

<style scoped>
</style>